import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function VideoPlayer({ src, posterUrl = "" }) {
  const { t } = useTranslation();
  const [playing, setPlaying] = useState(false);

  if (!posterUrl) {
    return (
      <video
        src={src}
        controls
        preload="metadata"
        playsInline
        className="w-full max-h-[480px] bg-black-900 block mx-auto"
      />
    );
  }

  if (playing) {
    return (
      <video
        src={src}
        poster={posterUrl}
        controls
        autoPlay
        playsInline
        className="w-full max-h-[480px] bg-black-900 block mx-auto"
      />
    );
  }

  return (
    <button
      type="button"
      onClick={() => setPlaying(true)}
      aria-label={t("video.play")}
      className="relative block w-full bg-black-900 group"
    >
      <img src={posterUrl} alt="" className="w-full max-h-[480px] object-contain block mx-auto" />
      <span className="absolute inset-0 flex items-center justify-center">
        <span className="w-16 h-16 rounded-full bg-black-900 bg-opacity-60 group-hover:bg-opacity-80 flex items-center justify-center transition-all">
          <svg viewBox="0 0 24 24" className="w-7 h-7 ml-1 text-white" fill="currentColor" aria-hidden="true">
            <path d="M8 5v14l11-7z" />
          </svg>
        </span>
      </span>
    </button>
  );
}